/**
 * Copyright (c) 2020-2021 Perficient, Inc.
 * Unauthorized copying or distribution of this file prohibited without the express permission of Perficient.
 */

import React from "react";

import { TeamsConfigSection } from "../components/IntegrationSettingsComponents/TeamsConfigSection";
import { AzureBotSection } from "../components/IntegrationSettingsComponents/AzureBotSection";
import { SocialMediaIntegrationSection } from "../components/IntegrationSettingsComponents/SocialMediaIntegrationSection";
import { PinpointIntegrationSection } from "../components/IntegrationSettingsComponents/PinpointIntegrationSection";
import { EmailIntegrationSection } from "../components/IntegrationSettingsComponents/EmailIntegrationSection";
import { ContentLayout, PanelContainer, ProgressOverlay } from "../../../components/Common";
import PageTabs from "../../../components/Common/PageTabs";
import { makeStyles } from "@material-ui/core";
import { useState } from "react";
import { useEffect } from "react";

const AzureIntegrationPage = ({ setTabModified, ...props }) => {
	const [teamsConfigEdited, setTeamsConfigEdited] = useState(false);
	const [azureBotEdited, setAzureBotEdited] = useState(false);

	useEffect(() => {
		setTabModified(teamsConfigEdited || azureBotEdited);
	}, [azureBotEdited, teamsConfigEdited, setTabModified]);

	return (
		<>
			<TeamsConfigSection setFormEdited={setTeamsConfigEdited} formEdited={teamsConfigEdited} {...props} />
			<AzureBotSection setFormEdited={setAzureBotEdited} formEdited={azureBotEdited} {...props} />
		</>
	);
};

const useStyles = makeStyles({
	tabs: {
		padding: "0 12px",
	},
});
/**
 * This page is used for editing Third Party Integrations settings.
 * Currently the settings available are the Teams and Facebook integrations
 */
const IntegrationsPage = () => {
	const [formEdited, setFormEdited] = React.useState(false);
	const [saving, setSaving] = React.useState(false);
	const [loading, setLoading] = React.useState(false);
	const classes = useStyles();

	const tabs = [
		{
			label: "Microsoft Teams",
			id: "Teams",
			component: <AzureIntegrationPage setSaving={setSaving} saving={saving} setPageLoading={setLoading} />,
			default: true,
		},
		{
			label: "Meta (Facebook)",
			id: "Meta",
			component: (
				<SocialMediaIntegrationSection
					setFormEdited={setFormEdited}
					formEdited={formEdited}
					setSaving={setSaving}
					saving={saving}
					setPageLoading={setLoading}
				/>
			),
			default: false,
		},
		{
			label: "Pinpoint (SMS)",
			id: "Pinpoint",
			component: (
				<PinpointIntegrationSection
					setFormEdited={setFormEdited}
					formEdited={formEdited}
					setSaving={setSaving}
					saving={saving}
					setPageLoading={setLoading}
				/>
			),
			default: false,
		},
		{
			label: "SES (Email)",
			id: "SES",
			component: (
				<EmailIntegrationSection
					setFormEdited={setFormEdited}
					formEdited={formEdited}
					setSaving={setSaving}
					saving={saving}
					setPageLoading={setLoading}
				/>
			),
			default: false,
		},
	];

	const onTabChange = () => {
		setFormEdited(false);
	};

	return (
		<ContentLayout>
			{(loading || saving) && <ProgressOverlay />}
			<PanelContainer>
				<PageTabs
					tabs={tabs}
					className={`w-100 ${classes.tabs}`}
					onTabChange={onTabChange}
					requireConfirmOnChange
					selectedTabInQueryString={true}
				/>
			</PanelContainer>
		</ContentLayout>
	);
};

export default IntegrationsPage;
